import React from 'react';

export const CreateAgenda = React.lazy(() => import('./CreateAgenda/CreateAgenda'));
